<div class="container" *ngIf="guiService.currentProgram && !guiService.reloadProgram">
  <p>{{"HOME.WELCOME-BACK" | translate }}, {{guiService?.userLogged?.masterData.name}}!</p>
  <h1>{{"HOME.BE-THE-BEST-YOU" | translate }}</h1>

  <div (click)="guiService.goTo('main/on-demand/time_challenge')" *ngIf="timeChallengeService.challenge" class="time-challenge" [style.background-image]="'url(https://play.vidyard.com/' + timeChallengeService.challenge.i18nThumb[translate.currentLang.toUpperCase()] + '.jpg)'">
   <div>
    <h3>{{timeChallengeService.challenge.i18nTitle[translate.currentLang.toUpperCase()]}}</h3>
    <p>{{timeChallengeService.formatDateAsString(timeChallengeService.challenge.startDate)}} - {{timeChallengeService.formatDateAsString(timeChallengeService.challenge.endDate)}}</p>
   </div>
    <button class="its-button accept-btn" *ngIf="timeChallengeService.acceptedChallenge === null">{{"BANNER_CHALLENGE.BTN" | translate}}</button>

    <span *ngIf="timeChallengeService.acceptedChallenge && !timeChallengeService.showCountdown" class="chall-ends">
      <p class="chall-end-at">{{"BANNER_CHALLENGE.CHALL_END_AT" | translate}}</p>
      <p class="weeks-out">{{timeChallengeService.challengeStartedBy()}}</p>
    </span>

    <span class="chall-countdown-container"  *ngIf="timeChallengeService.acceptedChallenge && timeChallengeService.showCountdown">
      <p class="chall-start-at">{{"BANNER_CHALLENGE.CHALL_START_AT" | translate}}</p>
      <div class="chall-countdown">
        <div>
        <span class="box">
          {{timeChallengeService.countdown && timeChallengeService.countdown.days < 10 ? 0 : null}}{{ timeChallengeService.countdown?.days }}
        </span>
        <p>{{"BANNER_CHALLENGE.DAYS" | translate}}</p>
        </div>
       <span class="point-divider">:</span>
        <div>
        <span class="box">
          {{timeChallengeService.countdown && timeChallengeService.countdown.hours < 10 ? 0 : null}}{{ timeChallengeService.countdown?.hours }}
        </span>
        <p>{{"BANNER_CHALLENGE.HOURS" | translate}}</p>
        </div>
        <span class="point-divider">:</span>
        <div>
        <span class="box">
          {{timeChallengeService.countdown && timeChallengeService.countdown.minutes < 10 ? 0 : null}}{{ timeChallengeService.countdown?.minutes }}
        </span>
        <p>{{"BANNER_CHALLENGE.MINUTES" | translate}}</p>
        </div>
        <span class="point-divider">:</span>
        <div>
        <span class="box">
          {{timeChallengeService.countdown && timeChallengeService.countdown.seconds < 10 ? 0 : null}}{{ timeChallengeService.countdown?.seconds }}
        </span>
         <p>{{"BANNER_CHALLENGE.SECS" | translate}}</p>
        </div>
      </div>
    </span>
  </div>

  <div class="week-progress">
    <p>{{"HOME.WEEK-PROGRESS" | translate}}</p>
    <div class="radial-chart">
      <svg class="circle" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <path class="circle-background" stroke="white" d="M18 2 a16 16 0 1 1 0 32 a16 16 0 1 1 0 -32"></path>
        <path class="circle-progress" [attr.stroke-dasharray]="getStrokeDashArray()" stroke="#db3687" d="M18 2 a16 16 0 1 1 0 32 a16 16 0 1 1 0 -32"></path>
      </svg>
      <div class="percentage">{{ percentage }}%</div>
    </div>
  </div>

  <div class="workout-program">
    <div class="header-titles">
      <h2>{{"HOME.WORKOUT-PROGRAM" | translate}}</h2>
      <p (click)="guiService.goTo('main/workout-programs')" class="change-program-btn">{{"HOME.CHANGE-PROGRAM" | translate}}</p>
    </div>
    <div class="current-program">
      <h2>{{guiService.currentProgram?.i18nName[translate.currentLang.toUpperCase()]}}</h2>
      <div class="data-line">
        <mat-icon svgIcon="mat:calendar_month"></mat-icon>
        <p>{{"HOME.WEEK" | translate}} {{guiService?.userLogged?.workoutInfo?.programs[guiService?.currentProgram?._id].week}}</p>
      </div>
      <div class="data-line">
        <mat-icon svgIcon="mat:accessibility"></mat-icon>
        <p>{{"HOME.WORKOUTS" | translate}}
          {{workoutCompletedInWeek()}}/{{countWeeklyWorkout()}}</p>
      </div>
      <div class="change-week">
        <p (click)="guiService.goTo('main/change-week')" class="change-week-btn">{{"HOME.CHANGE-WEEK" | translate}}</p>
        <mat-icon svgIcon="mat:arrow_forward"></mat-icon>
      </div>
      <img [src]="environment.node+'/program-image-by-id/'+guiService.currentProgram?._id" *ngIf="guiService.currentProgram?._id">
    </div>
  </div>

  <div class="workouts-of-week">
    <h2>{{"HOME.WORKOUTS-OF-THE" | translate}} <span>{{"HOME.WEEK" | translate}}
        {{guiService?.userLogged?.workoutInfo.programs[guiService?.currentProgram?._id].week}}</span></h2>
    <div class="workouts-slider">
      <swiper-container #swiperWorkouts [pagination]="true" [slidesPerView]="2.5">
        <swiper-slide
          *ngFor="let workout of guiService.currentProgram?.weeks[guiService?.userLogged?.workoutInfo.programs[guiService?.currentProgram?._id].week] | keyvalue; let i = index">
          <div class="workout-slide" [ngClass]="'workout-slide-'+i">
            <div class="workout-day">
              <p>{{"HOME.DAY" | translate}} {{i+1}}</p>
              <div class="mark-icon" *ngIf="getWorkoutValue(workout)?.id" (click)="openModalMarkWorkout(getWorkoutValue(workout)?.name[translate.currentLang.toUpperCase()], getWorkoutValue(workout)?.id, i)">
                <img *ngIf="!checkWorkoutStatus(getWorkoutValue(workout)?.id, guiService?.userLogged?.workoutInfo.programs[guiService?.currentProgram?._id].week, i)" src="../../assets/img/thunderbolt_outline_violet.svg" alt="">
                <img *ngIf="checkWorkoutStatus(getWorkoutValue(workout)?.id, guiService?.userLogged?.workoutInfo.programs[guiService?.currentProgram?._id].week, i)" src="../../assets/img/thunderbolt_violet.svg" alt="">
              </div>
              <div class="mark-icon-placeholder" *ngIf="!getWorkoutValue(workout)?.id"></div>
            </div>
            <div class="inner" (click)="getWorkoutValue(workout)?.id ? goToWorkout(getWorkoutValue(workout)?.id, guiService.evaluateBgColor(i), i) : null">
              <img class="workout-img" *ngIf="getWorkoutValue(workout)?.id" [src]="environment.workouts+'/'+getWorkoutValue(workout)?.id+'/images/main'">
              <img class="workout-img" *ngIf="!getWorkoutValue(workout)?.id" src="../../assets/img/rest.png">
            </div>
            <p class="workout-name" *ngIf="getWorkoutValue(workout)?.name">{{getWorkoutValue(workout).name[translate.currentLang.toUpperCase()]}}</p>
            <p class="workout-name" *ngIf="!getWorkoutValue(workout).name">{{"HOME.REST" | translate}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <div class="paginator-tutorial-placeholder"></div>
    </div>
  </div>

  <div class="banner">
    <h2 *ngIf="bannerSlides?.length > 0">{{"HOME.BANNER-TITLE" | translate}}</h2>

    <div class="banner-slider">
      <swiper-container #swiperBanner [pagination]="true" [loop]="true">
        <swiper-slide *ngFor="let slide of bannerSlides" [ngStyle]="{'background-color': slide.colorCode}">
            <div *ngIf="slide.imagePath" (click)="evaluateBannerRedirect(slide)"
              [ngStyle]="{ 'background-image': 'url(' + environment.node + '/get-banner-image/' + slide._id + ')' }"
              class="banner-background">
            </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</div>

<div class="container" *ngIf="!guiService.currentProgram || guiService.reloadProgram">
  <p>{{"HOME.WELCOME-BACK" | translate }}</p>
  <h1>{{"HOME.BE-THE-BEST-YOU" | translate }}</h1>

  <!-- Skeleton week progress -->
  <div class="week-progress skeleton" style="height: 90px; width: 100%; margin-bottom: 16px;"></div>

  <div class="workout-program">
    <div class="header-titles">
      <h2>{{"HOME.WORKOUT-PROGRAM" | translate}}</h2>
      <p (click)="guiService.goTo('main/workout-programs')">{{"HOME.CHANGE-PROGRAM" | translate}}</p>
    </div>
    <!-- Skeleton current program -->
    <div class="current-program skeleton" style="height: 156px; width: 100%; margin-bottom: 16px;"></div>
  </div>

  <div class="workouts-of-week">
    <h2>{{"HOME.WORKOUTS-OF-THE" | translate}} <span>{{"HOME.WEEK" | translate}}</span></h2>
    <div class="workouts-slider">
      <swiper-container [slidesPerView]="2.5">
        <swiper-slide *ngFor="let workout of placeholderSlides; let i = index">
          <div class="workout-slide">
            <div class="workout-day">
              <p>{{"HOME.DAY" | translate}} {{i+1}}</p>
              <div class="mark-icon-placeholder"></div>
            </div>
            <!-- Skeleton workout slide inner -->
            <div class="inner skeleton" style="height: 100px; width: 100%;"></div>
            <p class="workout-name">&nbsp;</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <div class="paginator-tutorial-placeholder"></div>
    </div>
  </div>

  <div class="banner">
    <h2>{{"HOME.BANNER-TITLE" | translate}}</h2>
    <!-- Skeleton banner -->
    <div class="banner-skeleton skeleton" style="height: 125px; border-radius: 12px; width: 100%;"></div>
  </div>
</div>
